import { FleetAlarm } from "../../../src/models/types/voy-fleet-alarm-model.types";
import { AlarmType, StaticInfoForAlarms } from "../../../src/services/types/fleet-alarms-service.types";

export function getStaticInfoWithTimeRemaining(alarm: FleetAlarm): string {
    const staticInfo = StaticInfoForAlarms[alarm.alarmType] || "No static info available";
    let result = staticInfo;

    if (alarm.alarmType === AlarmType.HeavyWeather || alarm.alarmType === AlarmType.ParametricRoll) {
        const remainingTime = getTimeRemaining(alarm.startTs);
        result += ` ${remainingTime}`;
    }

    return result;
}

function getTimeRemaining(startTs: string): string {
    const startTime = new Date(startTs).getTime();
    const currentTime = Date.now();
    const timeDiff = startTime - currentTime;

    if (timeDiff <= 0) {
        return "has passed or is ongoing";
    }

    const hours = Math.floor(timeDiff / (1000 * 60 * 60));

    return `within ${hours}h`;
}

export function fromDateMethod(newFromDate: Date, month: number): Date {
    newFromDate.setMonth(newFromDate.getMonth() - month);
    return newFromDate;
}

export const Tooltip_Text = `This information is from the vessel submitted plan.`
export const ToolTip_Data_Source = 'From schedule.'